import axios from 'axios';
import { simulatorBackend } from '@/application/api';
import { authenticationService } from '@/application/services/api-clients/login-service';

const getOptions = () => ({ headers: authenticationService.authHeader() });

const brokersRoute = 'brokers';

export const getBrokersList = async (body, cancelExecutor = () => { }) => {
  const cancelToken = new axios.CancelToken(cancelExecutor);
  const options = getOptions();
  options.cancelToken = cancelToken;
  const { data } = await simulatorBackend.post(`${brokersRoute}/getBrokersList`, body, options);
  return data;
};

export const getBrokerByEmail = async brokerEmail => {
  const { data } = await simulatorBackend.get(`${brokersRoute}/getBrokerByEmail/${brokerEmail}`, getOptions());
  return data;
};

export const getBrokerById = async brokerId => {
  const { data } = await simulatorBackend.get(`${brokersRoute}/${brokerId}`, getOptions());
  return data;
};

export const findBrokerBySearchString = async (searchString, cancelExecutor = () => { }) => {
  const cancelToken = new axios.CancelToken(cancelExecutor);
  const options = getOptions();
  options.params = { searchString };
  options.cancelToken = cancelToken;
  const { data } = await simulatorBackend.get(`${brokersRoute}/search`, options);
  return data.brokerDetails;
};

export const addBroker = async body => {
  const options = getOptions();
  const { data } = await simulatorBackend.post(`${brokersRoute}/addBroker`, body, options);
  return data;
};

export const updateBrokerStatus = async body => {
  const options = getOptions();
  const { data } = await simulatorBackend.patch(`${brokersRoute}/updateBrokerStatus`, body, options);
  return data;
};
